import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Package, Download, Loader2, ChevronRight, CheckCircle, AlertTriangle, FolderOpen } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';

export default function AssemblyExport() {
    const { getAuthHeaders, getToken } = useAuth();
    const navigate = useNavigate();
    const [expedientes, setExpedientes] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                const headers = await getAuthHeaders();
                const res = await fetch(`${API_URL}/api/expedientes`, { headers });
                const data = await res.json();
                if (data.ok) setExpedientes(data.expedientes);
            } catch (e) { /* */ }
            finally { setLoading(false); }
        })();
    }, []);

    const descargar = async (e, id) => {
        e.stopPropagation();
        const token = await getToken();
        window.open(`${API_URL}/api/expedientes/${id}/ensamblar?token=${token}`, '_blank');
    };

    return (
        <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
            <div style={{ marginBottom: '2rem' }}>
                <h1 style={{ fontSize: '1.875rem', fontWeight: 'bold' }}>5. Ensamblaje y Exportación</h1>
                <p style={{ color: 'hsl(var(--muted-foreground))' }}>
                    Empaqueta cada expediente en un ZIP organizado por sobre, con nomenclatura PLADICOP lista para SEACE.
                </p>
            </div>

            {loading ? (
                <div style={{ display: 'flex', justifyContent: 'center', padding: '3rem' }}><Loader2 className="animate-spin" size={28} /></div>
            ) : expedientes.length === 0 ? (
                <div className="card" style={{ padding: '3rem', textAlign: 'center', color: 'hsl(var(--muted-foreground))' }}>
                    <Package size={36} style={{ margin: '0 auto 0.75rem', opacity: 0.4 }} />
                    <p>Aún no tienes expedientes. Crea uno desde <strong>"1. Bases y TDR"</strong>.</p>
                </div>
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.85rem' }}>
                    {expedientes.map(e => {
                        const completo = e.resumen.progreso === 100;
                        const conObs = e.resumen.observados > 0;
                        return (
                            <div key={e.id} className="card" style={{ padding: '1.25rem', display: 'flex', alignItems: 'center', gap: '1rem', cursor: 'pointer' }}
                                onClick={() => navigate(`/expediente/${e.id}`)}>
                                <FolderOpen size={22} style={{ color: 'hsl(var(--primary))', flexShrink: 0 }} />
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <div style={{ fontWeight: 600, fontSize: '0.92rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{e.proceso?.objeto || 'Expediente'}</div>
                                    <div style={{ fontSize: '0.78rem', color: 'hsl(var(--muted-foreground))', marginTop: '0.2rem', display: 'flex', gap: '0.75rem', flexWrap: 'wrap', alignItems: 'center' }}>
                                        <span>{e.resumen.cargados}/{e.resumen.total} requisitos</span>
                                        {completo
                                            ? <span style={{ color: '#10b981', display: 'inline-flex', alignItems: 'center', gap: '0.25rem' }}><CheckCircle size={13} /> Completo</span>
                                            : <span style={{ color: '#f59e0b', display: 'inline-flex', alignItems: 'center', gap: '0.25rem' }}><AlertTriangle size={13} /> {e.resumen.progreso}%</span>}
                                        {conObs && <span style={{ color: '#ef4444', display: 'inline-flex', alignItems: 'center', gap: '0.25rem' }}><AlertTriangle size={13} /> {e.resumen.observados} observados</span>}
                                    </div>
                                </div>
                                <button onClick={(ev) => descargar(ev, e.id)} disabled={e.resumen.cargados === 0}
                                    style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem', padding: '0.55rem 1rem', background: e.resumen.cargados === 0 ? 'hsl(var(--muted))' : 'hsl(var(--primary))', color: 'white', border: 'none', borderRadius: 'var(--radius)', cursor: e.resumen.cargados === 0 ? 'not-allowed' : 'pointer', fontWeight: 600, fontSize: '0.82rem', flexShrink: 0 }}>
                                    <Download size={15} /> ZIP
                                </button>
                                <ChevronRight size={18} style={{ color: 'hsl(var(--muted-foreground))', flexShrink: 0 }} />
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
